import React from 'react'

import { Grid, Typography } from '@material-ui/core'

import useStyles from './styles'

const SectionText = ({ text, regularBottom, italic, light }) => {
  const { root, description } = useStyles({ regularBottom, italic, light })
  return (
    <Grid container className={root}>
      <Typography component="p" className={description}>
        {text}
      </Typography>
    </Grid>
  )
}

export default SectionText
